/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';
import { MenuItem, MenuItemClickEvent } from '../types';

@Component({
  selector: 'bulb-menu-item-action',
  templateUrl: './menu-item-action.component.html',
  styleUrls: ['./menu-item-action.component.scss'],
  standalone: false,
})
export class MenuItemActionComponent {
  @Input() menuItem: MenuItem;

  /**
   * Event emitter for menu items when clicked.
   */
  @Output() menuItemClicked: EventEmitter<MenuItemClickEvent> = new EventEmitter<MenuItemClickEvent>();

  onDisabledAction($event: MouseEvent, menuItem: MenuItem) {
    if (this.menuItem.disabledAction && this.menuItem.disabled) {
      this.menuItem.disabledAction();
      this.menuItemClicked.emit({ $event, menuItem });
    }
  }
}
